export default import.meta.ROLLDOWN_FILE_URL_wotOSvmQI$mysMr64mNvVw